import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WorkItem {
	id: string;
	feature: string;
	description: string;
	hours: number;
	projectName?: string;
	status?: string;
	activityType?: string;
}

interface WorkReviewData {
	workItems: WorkItem[];
	discussionPoints: string;
	actionTaken: string;
	capabilities: string;
	improvements: string;
	suggestions: string;
	supervisor: string;
	joining: string | null;
	goals: any[];
}

interface WorkReviewState {
	[userName: string]: WorkReviewData;
}

const initialState: WorkReviewState = {};

const workReviewSlice = createSlice({
	name: 'workReview',
	initialState,
	reducers: {
		updateWorkReviewData: (state, action: PayloadAction<{ userName: string; data: Partial<WorkReviewData> }>) => {
			const { userName, data } = action.payload;
			if (!state[userName]) {
				state[userName] = {
					workItems: [],
					discussionPoints: '',
					actionTaken: '',
					capabilities: '',
					improvements: '',
					suggestions: '',
					supervisor: '',
					joining: new Date().toISOString(),
					goals: [],
				};
			}
			state[userName] = { ...state[userName], ...data };
		},
		resetWorkReviewData: (state, action: PayloadAction<string>) => {
			const userName = action.payload;
			state[userName] = {
				workItems: [],
				discussionPoints: '',
				actionTaken: '',
				capabilities: '',
				improvements: '',
				suggestions: '',
				supervisor: '',
				joining: new Date().toISOString(),
				goals: [],
			};
		}
	}
});

export const { updateWorkReviewData, resetWorkReviewData } = workReviewSlice.actions;
export default workReviewSlice;